import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	fetchGeoblockGroupsItem,
	dictionaryGeoblockGroups,
	dictionaryCountriesWithCodes
} from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import utilities
import { submitForm } from 'components/utilities/form';

// Validate
import validate from './validation';

// Import components
import { FormTemplate } from 'components/common/templates';
import { FormButtons } from 'components/common/buttons';
import Fields from './fields/Fields';
import InfoTitle from 'components/utilities/info/InfoTitle';

// Import helpers
import {
	convertDictionaryCountriesCodes,
	convertInitialValues
} from './helpers';

const GeoblockGroupForm = ({
	history,
	fetchGeoblockGroupsItem,
	error,
	isLoaded,
	initialValues,
	dictionaryGeoblockGroups,
	dictionaryCountriesWithCodes,
	geoblockGroups,
	countriesWithCodes
}) => {
	const { t } = useTranslation();

	const handleOnSubmit = ({ isEdit, itemID }) => async ({
		countries,
		name
	}) => {
		// // Submit the form with field values
		await submitForm({
			history,
			isEdit,
			itemID,
			resources: { countries, name },
			api: 'geoblocking',
			redirectPath: 'geoblock_groups',
			notificationName: 'geoblock/groups'
		});
	};

	const convertedCountriesCodes = convertDictionaryCountriesCodes(
		countriesWithCodes
	);

	const { initalCountries, initalGeoblockGroups } = convertInitialValues({
		initialValues,
		geoblockGroups
	});

	const formInitialValues = {
		...initialValues,
		countries: initalCountries,
		geoblock_groups: initalGeoblockGroups
	};

	return (
		// Dispatch fetchGeoblockGroupsItem actions in in geoblock_groups
		<div style={{ paddingBottom: 120 }}>
			<FormTemplate
				fetchResourceToEdit={fetchGeoblockGroupsItem}
				fetchFormResources={[
					dictionaryGeoblockGroups,
					dictionaryCountriesWithCodes
				]}
				error={error}
				isLoaded={isLoaded}
			>
				{({ isEdit, itemID, checkedPermissions, decorators }) => (
					<Form
						initialValues={formInitialValues}
						validate={validate}
						decorators={decorators}
						onSubmit={handleOnSubmit({ isEdit, itemID })}
						render={({ handleSubmit, submitting }) => (
							<form onSubmit={handleSubmit}>
								<InfoTitle title={t('geoblock_groups:info_text')} />
								<Fields
									isEdit={isEdit}
									checkedPermissions={checkedPermissions}
									geoblockGroups={geoblockGroups}
									countries={convertedCountriesCodes}
								/>

								<FormButtons
									isButtonDisabled={submitting || error}
									path="geoblock_groups"
									buttonText={t('common:buttons.submit')}
								/>
							</form>
						)}
					/>
				)}
			</FormTemplate>
		</div>
	);
};

GeoblockGroupForm.propTypes = {
	history: PropTypes.object.isRequired,
	initialValues: PropTypes.object.isRequired,
	fetchGeoblockGroupsItem: PropTypes.func.isRequired,
	error: PropTypes.bool.isRequired,
	isLoaded: PropTypes.bool.isRequired,
	dictionaryGeoblockGroups: PropTypes.func.isRequired,
	dictionaryCountriesWithCodes: PropTypes.func.isRequired,
	geoblockGroups: PropTypes.array.isRequired,
	countriesWithCodes: PropTypes.object.isRequired
};

const mapStateToProps = ({
	geoblock_groups: { form },
	dictionary: { geoblockGroups, countriesWithCodes }
}) => {
	return {
		initialValues: form.edit,
		error: form.error,
		isLoaded: form.isLoaded,
		geoblockGroups,
		countriesWithCodes
	};
};

export default compose(
	connect(mapStateToProps, {
		fetchGeoblockGroupsItem,
		dictionaryGeoblockGroups,
		dictionaryCountriesWithCodes
	}),
	withRouter
)(GeoblockGroupForm);
